import get from 'lodash/get'
import * as Sentry from '@sentry/browser'
import {
  CREATE_HOME_REQUEST,
  CREATE_HOME_SUCCESS,
  CREATE_HOME_FAILURE,
  FETCH_HOME_REQUEST,
  CREATE_HOME_FETCH_COMPILED_FAILURE,
  FETCH_HOME_SUCCESS,
  FETCH_HOME_SUCCESS_FOR_BUYER
} from './actionTypes'
import { getHomeDetail } from '../api/mikasa/requests'
import { createHome as createHomeRequest } from '../api/mikasa/requests'
import { fetchClientHomes } from './client'
import { selectClientId } from '../store/selectors/client'
import poll from './poll'
import TimeoutError from './TimeoutError'
import { redirect } from '../helpers/browser'
import { PATH_HELPERS } from '../constants/navigation'

export const createHomeFailure = error => ({
  type: CREATE_HOME_FAILURE,
  error: get(error, 'response.data.errors', get(error, 'message'))
})

export const createHome =
  (home, withRedirect = true) =>
  async (dispatch, getState) => {
    dispatch({
      type: CREATE_HOME_REQUEST
    })

    const state = getState()
    const clientId = selectClientId(state)

    try {
      const response = await createHomeRequest({
        home,
        clientId
      })

      dispatch({
        type: CREATE_HOME_SUCCESS,
        data: response.data
      })
      const homeId = response.data.data.legacyRef
      dispatch(fetchCompiledHome(homeId, withRedirect))
      dispatch(fetchClientHomes(clientId))
    } catch (error) {
      dispatch(createHomeFailure(error))

      Sentry.captureException(error)
    }
  }

export const fetchHomeSuccess = (type, response) => {
  return {
    type,
    data: response.data,
    loading: true
  }
}

export const fetchCompiledHome = (homeId, withRedirect) => {
  return async (dispatch, getState) => {
    dispatch({
      type: FETCH_HOME_REQUEST,
      id: homeId
    })

    try {
      const response = await poll(
        () => getHomeDetail({ homeId }),
        response => get(response, 'data.processed')
      )

      if (withRedirect) {
        dispatch(fetchHomeSuccess(FETCH_HOME_SUCCESS, response))
        redirect(PATH_HELPERS.home.buildPath(selectClientId(getState()), homeId))
      } else {
        dispatch(fetchHomeSuccess(FETCH_HOME_SUCCESS_FOR_BUYER, response))
      }
    } catch (error) {
      dispatch({
        type: CREATE_HOME_FETCH_COMPILED_FAILURE,
        error: error.message,
        timeout: error instanceof TimeoutError
      })

      Sentry.captureException(error, {
        extra: {
          homeId
        }
      })
    }
  }
}
